import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("proxilia_token");
    if (!token) { setUser(false); setReady(true); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => { localStorage.removeItem("proxilia_token"); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("proxilia_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("proxilia_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
